import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import { SelectItem } from 'primeng/primeng';
import { Observable } from 'rxjs/Observable';
import { CalendarTranslate } from '../../../../models/calendarTranslate.model';
import { CustomerFamilyInfo } from '../../../../models/customer.model';
import { CalendarTranslateService } from '../../../../modules/UIKit/services/calendarTranslate.service';
import { KoncentroValidators } from '../../../../modules/UIKit/validators/koncentro-validators';
import { CivilStatusService } from '../../../../services/civil-status/civil-status.service';
import { CustomerInfoService } from '../../../../services/customer/customerinfo.service';
import { EducationService } from '../../../../services/education/education.service';
import { EmploymentService } from '../../../../services/employment/employment.service';
import { FormValidationService } from '../../../../services/utils/form-validation.service';


@Component({
  selector: 'app-customer-familyinfo',
  templateUrl: './familyinfo.component.html',
  providers: [
    CalendarTranslateService
  ]
})
export class CustomerDetailFamilyInfoComponent implements OnInit {

  @Input() customerId: string;

  @Output() dirtyFormData = new EventEmitter();

  validationData = null;
  formData: FormGroup;
  titlePage: 'customerDetail.addNew';
  employments: SelectItem[] = [];
  educations: SelectItem[] = [];
  civilStatuses: SelectItem[] = [];
  maxChildren = 5;
  minChildren = 0;
  today: Date = new Date();
  sessi: Array<{ value: string, label: string }>;
  calendarTranslate: CalendarTranslate;


  constructor (
    private fb: FormBuilder,
    private translate: TranslateService,
    private srvCustomer: CustomerInfoService,
    private srvEducation: EducationService,
    private srvEmployment: EmploymentService,
    private srvCivilStatus: CivilStatusService,
    private srvCalendarTranslate: CalendarTranslateService,
    private formValidation: FormValidationService,
  ) {

  }

  ngOnInit(): void {

    this.employments = [{value: null, label: ''}];
    this.educations = [{value: null, label: ''}];
    this.civilStatuses = [{value: null, label: ''}];
    this.sessi = [{value: '', label: ''}];


    /*
    this.srvCalendarTranslate.pCalendar.subscribe(res => {
      this.calendarTranslate = res;
    });
    */
    this.srvCalendarTranslate.pCalendar.subscribe(c => {
      this.calendarTranslate = c
    });

    Observable.zip(
      this.srvEmployment.getList(),
      this.srvEducation.getList(),
      this.srvCivilStatus.getList(),
      this.srvCustomer.getFamilyInfo(this.customerId),

      this.translate.get([
        'customerDetail.sex_male',
        'customerDetail.sex_female'
      ])

    ).subscribe(([resEmployment, resEducation, resCivilStatus, resInfo, translations]) => {

      for (const singleEmployment of resEmployment) {
        this.employments.push({
          value: singleEmployment.id,
          label: singleEmployment.name
        });
      }

      for (const singleEducation of resEducation) {
        this.educations.push({
          value: singleEducation.id,
          label: singleEducation.description + ' (' + singleEducation.title + ')'
        });
      }

      for (const singleStatus of resCivilStatus) {
        this.civilStatuses.push({
          value: singleStatus.id,
          label: singleStatus.name
        });
      }

      this.sessi.push(
        { value: 'M', label: translations['customerDetail.sex_male']},
        { value: 'F', label: translations['customerDetail.sex_female']}
      );

      this.createForm(resInfo);
    });

    this.validationData = {ms_base_url: this.srvCustomer.getBaseUrl(), dto_name: 'CustomerFamilyInfoDto', form: this.formData};
  }

  onChanges(): void {
    this.formData.valueChanges.subscribe(() => this.dirtyFormData.emit(this.formData.dirty));
  }

  evaluateChildrenCount()  {
    if (this.formData.get('children_number') && this.formData.get('children_number').value != null) {
      const children: number[] = [];

      for (let i = 0; i < this.formData.get('children_number').value; i++) {
        children.push(i);
      }

      return children;
    }

    return [];
  }

  evaluateFormControlName(index): any {
    switch (index) {
      case 0:
        return {
          sex: 'first_son_sex',
          employment: 'first_son_employment',
          education: 'first_son_education',
          birthday: 'first_son_birthday'
        };
      case 1:
        return {
          sex: 'second_son_sex',
          employment: 'second_son_employment',
          education: 'second_son_education',
          birthday: 'second_son_birthday'
        };
      case 2:
        return {
          sex: 'third_son_sex',
          employment: 'third_son_employment',
          education: 'third_son_education',
          birthday: 'third_son_birthday'
        };
      case 3:
        return {
          sex: 'fourth_son_sex',
          employment: 'fourth_son_employment',
          education: 'fourth_son_education',
          birthday: 'fourth_son_birthday'
        };
      case 4:
        return {
          sex: 'fifth_son_sex',
          employment: 'fifth_son_employment',
          education: 'fifth_son_education',
          birthday: 'fifth_son_birthday'
        };
    }
  }

  createForm(data: CustomerFamilyInfo) {
    let isNew = data == null;
    this.formData = this.fb.group({
      civil_status_id: (!isNew) ? new FormControl(data.civil_status_id) : null,
      children_number: (!isNew) ? new FormControl(data.children_number, KoncentroValidators.integerNotNegative) : null,
      relative_members: (!isNew) ? new FormControl(data.relative_members, KoncentroValidators.integerNotNegative) : null,

      mate_birthday: (!isNew && data.mate_birthday) ? new FormControl(moment(data.mate_birthday).toDate(), KoncentroValidators.dateNotAfter(this.today)) : null,
      mate_birth_place: (!isNew && data.mate_birth_place) ? new FormControl(data.mate_birth_place) : null,
      mate_education: (!isNew && data.mate_education) ? new FormControl(data.mate_education) : null,
      mate_employment: (!isNew && data.mate_employment) ? new FormControl(data.mate_employment) : null,
      mate_name: (!isNew && data.mate_name) ? new FormControl(data.mate_name) : null,
      mate_surname: (!isNew && data.mate_surname) ? new FormControl(data.mate_surname) : null,
      mate_sex: (!isNew && data.mate_sex) ? new FormControl(data.mate_sex) : null,

      first_son_education: (!isNew && data.first_son_education) ? new FormControl(data.first_son_education) : null,
      first_son_employment: (!isNew && data.first_son_employment) ? new FormControl(data.first_son_employment) : null,
      first_son_sex: (!isNew && data.first_son_sex) ? new FormControl(data.first_son_sex) : null,
      first_son_birthday: (!isNew && data.first_son_birthday) ? new FormControl(moment(data.first_son_birthday).toDate(), KoncentroValidators.dateNotAfter(this.today)) : null,

      second_son_education: (!isNew && data.second_son_education) ? new FormControl(data.second_son_education) : null,
      second_son_employment: (!isNew && data.second_son_employment) ? new FormControl(data.second_son_employment) : null,
      second_son_sex: (!isNew && data.second_son_sex) ? new FormControl(data.second_son_sex) : null,
      second_son_birthday: (!isNew && data.second_son_birthday) ? new FormControl(moment(data.second_son_birthday).toDate(), KoncentroValidators.dateNotAfter(this.today)) : null,

      third_son_education: (!isNew && data.third_son_education) ? new FormControl(data.third_son_education) : null,
      third_son_employment: (!isNew && data.third_son_employment) ? new FormControl(data.third_son_employment) : null,
      third_son_sex: (!isNew && data.third_son_sex) ? new FormControl(data.third_son_sex) : null,
      third_son_birthday: (!isNew && data.third_son_birthday) ? new FormControl(moment(data.third_son_birthday).toDate(), KoncentroValidators.dateNotAfter(this.today)) : null,

      fourth_son_education: (!isNew && data.fourth_son_education) ? new FormControl(data.fourth_son_education) : null,
      fourth_son_employment: (!isNew && data.fourth_son_employment) ? new FormControl(data.fourth_son_employment) : null,
      fourth_son_sex: (!isNew && data.fourth_son_sex) ? new FormControl(data.fourth_son_sex) : null,
      fourth_son_birthday: (!isNew && data.fourth_son_birthday) ? new FormControl(moment(data.fourth_son_birthday).toDate(), KoncentroValidators.dateNotAfter(this.today)) : null,

      fifth_son_education: (!isNew && data.fifth_son_education) ? new FormControl(data.fifth_son_education) : null,
      fifth_son_employment: (!isNew && data.fifth_son_employment) ? new FormControl(data.fifth_son_employment) : null,
      fifth_son_sex: (!isNew && data.fifth_son_sex) ? new FormControl(data.fifth_son_sex) : null,
      fifth_son_birthday: (!isNew && data.fifth_son_birthday) ? new FormControl(moment(data.fifth_son_birthday).toDate(), KoncentroValidators.dateNotAfter(this.today)) : null

    });

    /*
    var self = this;
    setTimeout(function(){
      self.calendarTranslate = self.srvCalendarTranslate.pcalendarTranslate;
    },100)
    */
   this.onChanges();
  }

  public customSave(): Observable<any> {
    if (!this.formData.valid) {
      this.formValidation.validateAllFormFields(this.formData);
      return Observable.of(false);
    }

    return this.srvCustomer.putFamilyInfo(this.customerId, this.formData.value);
  }

}



// WEBPACK FOOTER //
// ./src/app/views/customerDB/customers/familyinfo/familyinfo.component.ts